module.exports = __webpack_public_path__ + "img/pattern2.38185b3.svg";